<template>

</template>

<script>
    import httpUrl from "@/static/configUrl";

    export default {
        name: "ssoLogin",
        created() {
            // debugger
            if (this.$route.query.ResponseTicket == null || this.$route.query.ResponseTicket == undefined) {
                this.ssoLogin()
            } else {
                this.getToken()
            }

        },
        methods: {
            ssoLogin() {
                debugger
                const that = this
                const domain = window.location.host
                const urlHttp = 'http://' + domain + "/ssoLogin"
                that.$store.dispatch('httpGet', {
                    "curl": httpUrl.messageUrl + "/eos_common/ssoLoginUrl",
                    "RequestUrl": urlHttp
                }).then(function (res) {
                    debugger
                    if (res.flag) {
                        window.location.href = res.ssoLoginUrl
                    } else {
                        that.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                }, function (err) {
                    console.log('err', err.message)
                })
            },
            getToken() {
                console.log('获取token')
                const urlToken = window.location.search
                var oGetVars = {}
                // var resToken
                const that = this
                if (urlToken.length > 1) {
                    for (var aItKey, nKeyId = 0, aCouples = urlToken.substr(1).split('&'); nKeyId < aCouples.length; nKeyId++) {
                        aItKey = aCouples[nKeyId].split('=')
                        oGetVars[decodeURIComponent(aItKey[0])] = aItKey.length > 1 ? decodeURIComponent(aItKey[1]) : ''
                    }
                }
                console.log(oGetVars, 'ticket')
                if (oGetVars.ResponseTicket == '' || oGetVars.ResponseTicket == undefined) {
                    this.$store.commit('getToken', '')
                    window.location.reload()
                } else {
                    // 如果ssoPath 是ssoLogin 的话就跳到首页
                    that.$store.commit('getToken', oGetVars.ResponseTicket)
                    let _data = {
                        curl: httpUrl.userUrl + '/account/token',
                        ticket: oGetVars.ResponseTicket
                    }
                    that.$store.dispatch('httpGet', _data).then(function (res) {
                        if (res.flag) {
                            that.$store.commit('getJwtToken', res.data.token)
                            that.$store.commit('getUserInfo', res.data.info)
                            console.log(that.$store.state)
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    }, function (err) {
                        console.log('err', err.message)
                    })
                    that.$router.push('/')

                    /* if (that.$store.state.myRequest.ssoPath == '' || that.$store.state.myRequest.ssoPath == undefined) {
                         that.$router.push({
                             path: "/workplace"

                         })
                     } else {
                         that.$router.push({
                             path: that.$store.state.myRequest.ssoPath
                         })
                     }*/
                }
            },
        }
    }
</script>

<style scoped>

</style>
